// Map legacy emoji (from older habits/categories) onto BuzerIcon set names, plus a resolver that
// accepts either a set name or a known emoji. Extracted from App.jsx so any component can render a
// stored icon without depending on the monolith.
import { ICON_NAMES } from "../BuzerIcons";

export const EMOJI_TO_NAME = {
  "💧": "drop", "🚿": "shower", "🚰": "water", "🥤": "glass", "🍵": "mug", "☕": "mug",
  "🧘": "meditation", "🧘‍♀️": "meditation", "🧘‍♂️": "meditation", "🙏": "pray",
  "📖": "book", "📚": "book", "📕": "book", "📗": "book", "📘": "book", "📓": "journal", "📔": "journal",
  "🤸": "stretch", "🤸‍♀️": "stretch", "🤸‍♂️": "stretch", "🏃": "run", "🏃‍♀️": "run", "🏃‍♂️": "run",
  "🚶": "walk", "🚶‍♀️": "walk", "🚶‍♂️": "walk", "👣": "footprints", "🦶": "footprints", "👟": "shoe", "👞": "shoe",
  "😴": "bed", "💤": "bed", "🛏️": "bed", "🛌": "bed",
  "📌": "pin", "⭐": "star2", "🌟": "star2", "✨": "sparkles",
  "🤝": "people", "👥": "people", "🚫": "cross", "⛔": "cross", "❌": "cross",
  "😇": "smile", "🙂": "smile", "😊": "smile", "😀": "smile", "🤗": "heart", "❤️": "heart", "❤": "heart", "💖": "heart",
  "🔔": "bell", "🍴": "plate", "🍽️": "plate", "🍽": "plate", "🌳": "tree", "🌲": "tree",
  "🏋️": "dumbbell", "🏋️‍♀️": "dumbbell", "🏋️‍♂️": "dumbbell", "💪": "dumbbell",
  "🍎": "apple", "🥗": "bowl", "🥣": "bowl", "🍞": "bread", "🥚": "egg", "🥕": "carrot",
  "☀️": "sun", "🌞": "sun", "🌙": "moon", "🌜": "moon", "📅": "calendar", "🗓️": "calendar",
  "⏰": "alarm", "⏱️": "stopwatch", "⏲️": "stopwatch", "🎯": "target", "💊": "pill", "🦷": "tooth",
  "🚲": "bike", "🏊": "swim", "🏊‍♀️": "swim", "🏊‍♂️": "swim", "🎵": "music", "🎶": "music", "🎧": "headphones",
  "💼": "briefcase", "💻": "laptop", "🖥️": "laptop", "📝": "pen", "✏️": "pencil", "🖊️": "pen",
  "🧹": "broom", "♻️": "recycle", "🔑": "key", "🛒": "shop", "🛍️": "shop", "🎁": "gift",
  "🌸": "flower", "🌼": "flower", "🌿": "herb", "🍃": "leaf", "🐾": "paw", "🐱": "cat", "🐦": "bird", "🐟": "fish",
  "⚽": "ball", "🏔️": "mountain", "⛰️": "mountain", "🧭": "compass", "🌍": "globe", "🌎": "globe",
  "📞": "call", "☎️": "phone", "📷": "camera", "📸": "camera", "🎤": "mic", "💡": "bulb",
  "🧠": "brain", "🩹": "bandage", "🌡️": "thermometer", "⚖️": "scale", "🧩": "puzzle", "👑": "crown",
  "🏆": "trophy", "🚩": "flag", "🔥": "flame", "💨": "wind", "🌧️": "rain", "❄️": "snow", "🕯️": "candle",
  "🥇": "medal", "🏅": "medal", "🎖️": "medal", "🎖": "medal", "🥈": "medal", "🥉": "medal",
  "🧴": "bottle", "🍰": "cake", "🍒": "cherries", "🎓": "ucenie", "👤": "user", "🛡️": "shield",
};

export function resolveIcon(icon) {
  if (!icon) return "";
  if (ICON_NAMES.includes(icon)) return icon;        // already a set name
  return EMOJI_TO_NAME[icon] || "";                  // mapped emoji, or "" if unknown
}

// Relatívny jas hex farby (#rgb / #rrggbb) 0..1; null ak sa nedá rozparsovať.
function hexLuminance(hex) {
  if (typeof hex !== "string") return null;
  let h = hex.trim().replace(/^#/, "");
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const lin = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
}

// v31 — kontrastná farba ikony na plnej výplni: biela na tmavej, tmavá na svetlej.
// Neznáma/neparsovateľná farba → biela (bezpečný default). Vracia CSS var (bez surového hexu).
export function iconContrast(color) {
  const l = hexLuminance(color);
  return l != null && l > 0.6 ? "var(--on-solid-dark)" : "var(--on-solid)";
}

// v2 — style for an icon chip with a chosen theme colour (habit/routine `icon_color`).
// v31 — rovnaký štýl ako štatistické dlaždice v Prehľade: PLNÉ farebné pozadie + biela/čierna
// ikona (podľa jasu). Returns undefined when no colour is set, so the chip keeps its default look.
export function iconChipStyle(color) {
  if (!color) return undefined;
  return {
    background: color,
    color: iconContrast(color),
    borderColor: color,
  };
}
